var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReduceRedness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.852,
    height: 82.064,
    viewBox: "0 0 74.852 82.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19084.688 19287.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.776,46.9l-.044.035a5.868,5.868,0,0,0-2.148,3.467,4.331,4.331,0,0,0,.821,3.573,4.183,4.183,0,0,0,2.154,1.4c.091.026.183.051.276.071s.176.035.265.05a5.163,5.163,0,0,0,.559.06c.052,0,.106,0,.159,0s.1,0,.152,0a5.933,5.933,0,0,0,3.572-1.286l.044-.035a5.864,5.864,0,0,0,2.151-3.466,4.332,4.332,0,0,0-.824-3.573c-1.6-1.992-4.8-2.123-7.137-.293",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.442,46.9l.043.035a5.858,5.858,0,0,1,2.148,3.467,4.331,4.331,0,0,1-.82,3.573,4.192,4.192,0,0,1-2.154,1.4c-.091.026-.183.051-.276.071s-.177.035-.266.05a5.163,5.163,0,0,1-.559.06c-.052,0-.1,0-.159,0s-.1,0-.152,0a5.937,5.937,0,0,1-3.572-1.286l-.044-.035a5.869,5.869,0,0,1-2.151-3.466,4.332,4.332,0,0,1,.825-3.573c1.6-1.992,4.8-2.123,7.137-.293",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.7,51.052c-.1.446-.439.544-1.743,1.45a4.777,4.777,0,0,1-4.9,0c-1.3-.906-1.639-1-1.743-1.45",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.272,37.4a3.322,3.322,0,0,1,4.089.022,7.966,7.966,0,0,0,3.406,1.742,8.338,8.338,0,0,0,2.682.141,19.675,19.675,0,0,0,3.528-.847c.833-.234,1.532-.434,2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.557,40.653a3.19,3.19,0,0,1,2.507-1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.553,37.4a3.322,3.322,0,0,0-4.089.022,7.966,7.966,0,0,1-3.406,1.742,8.333,8.333,0,0,1-2.681.141,19.654,19.654,0,0,1-3.529-.847c-.833-.234-1.532-.434-2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.761,38.959a3.19,3.19,0,0,1,2.507,1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.254,19.283c.2,6.293-.736,30.857.679,36.191,2.482,9.324,13.7,18.48,20.754,23.456a9.984,9.984,0,0,0,11.674,0c2.172-1.53,4.737-3.458,7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.522,33.683c-.2,6.293.736,16.457-.679,21.791-2.482,9.324-13.7,18.48-20.754,23.456a9.987,9.987,0,0,1-11.674,0c-2.172-1.53-4.737-3.458-7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.925,29.741a8.669,8.669,0,0,0-5.187-2.767,28.444,28.444,0,0,0-8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.992,29.7a8.669,8.669,0,0,1,5.187-2.767,28.452,28.452,0,0,1,8.128,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.372,5.618A165.334,165.334,0,0,1,808.988,16.48c10.5,9.683,18.069,23.972,24.264,41.646",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 12.251,
    x2: 23.059,
    transform: "translate(-19076.746 -19281.293)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.228,
    x2: 8.049,
    transform: "translate(-19049.627 -19285.936)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.073,
    x2: 7.662,
    transform: "translate(-19036.971 -19275.781)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.283,
    x2: 3.201,
    transform: "translate(-19022.209 -19255.77)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.812,
    x2: 4.518,
    transform: "translate(-19026.156 -19262.564)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.718,
    x2: 1.792,
    transform: "translate(-19018.391 -19249.236)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.877,
    x2: 2.188,
    transform: "translate(-19016.363 -19242.734)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.505,
    x2: 1.26,
    transform: "translate(-19013.652 -19236.463)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.255,
    x2: 5.624,
    transform: "translate(-19030.688 -19269.58)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.265,
    x2: 8.143,
    transform: "translate(-19041.811 -19281.619)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.686,65.3a1.374,1.374,0,0,1-.331-.064c.029-.04.043-.062.043-.062l-.2,0c-1.614-.708-2.965-4.189-3.942-4.565a7.888,7.888,0,0,0-2.32.392c-.392.114-1.8-.621-2.14-.441-.663.347-1.144,1.487-1.618,2.565a5.858,5.858,0,0,1-1.824,2.217h-.016l.006.007c-.1.071.15.174.15.174.827,1.014,2.182,3.284,6,3.166,3.239-.1,5.35-2.754,5.806-3.384Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.134,25.125c-1.136,3.689-6.322,7.343-6.322,14.176s1.547,8.7,5.074,8.7",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.379,43.435c-.572,3.063-1.9,3.065-3.278,3.065a1.5,1.5,0,0,0,0,3c2.414,0,3.976-.8,4.97-2.221q-.829-1.958-1.692-3.844",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.054,30.983V15.563l1.657-1.078,20.817-11.06",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceRedness);
export default __webpack_public_path__ + "static/media/reduce-redness.b5cfa375.svg";
export { ForwardRef as ReactComponent };